import { z } from 'zod';
import { DateOnlySchema } from '../date-only.ts';

/** ISO 8601 instant in UTC. Distinct from DateOnly, which has no time or zone. */
export const InstantSchema = z.string().datetime();
export type Instant = string;

export const IdSchema = z.string().min(1);

/** Audit fields every stored document carries. */
export const AuditSchema = z.object({
  createdAt: InstantSchema,
  createdBy: IdSchema,
  updatedAt: InstantSchema,
  updatedBy: IdSchema,
});

/**
 * Who may see a record.
 *
 * Audiences are additive; `private` overrides them all and restricts the
 * record to its creator. Defaults come from company settings per module.
 */
export const VisibilitySchema = z.object({
  internal: z.boolean(),
  subs: z.boolean(),
  owner: z.boolean(),
  private: z.boolean(),
});
export type Visibility = z.infer<typeof VisibilitySchema>;

export const INTERNAL_ONLY: Visibility = {
  internal: true,
  subs: false,
  owner: false,
  private: false,
};

export const AddressSchema = z.object({
  line1: z.string(),
  line2: z.string().optional(),
  city: z.string(),
  state: z.string(),
  postalCode: z.string(),
  country: z.string().default('US'),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
});
export type Address = z.infer<typeof AddressSchema>;

export const AttachmentSchema = z.object({
  fileId: IdSchema,
  name: z.string(),
  size: z.number().int().nonnegative(),
  contentType: z.string(),
  thumbnailUrl: z.string().optional(),
});
export type Attachment = z.infer<typeof AttachmentSchema>;

export { DateOnlySchema };
